import React from 'react';
import Tittle from '../Tittle';
import p11 from '../../img/projects/one/p11.JPG'
import p12 from '../../img/projects/one/p12.JPG'
import p13 from '../../img/projects/one/p13.JPG'

const ProjectsOne = () => {
    const one = {
        id: 1,
        title: 'Hp Tech',
        live: 'Live Site',
        link: 'https://sleepy-panini-86b83d.netlify.app',
        linkgc: 'https://github.com/alihaydararman/hp-laptop-client-site',
        linkgs: 'https://github.com/alihaydararman/hp-laptop-server-side',
        git: 'GitHub(Client)',
        gits: 'GitHub(Server)',
        date: '21',
        month: 'Mar',
        year: '2020',
        details: 'Details',
        projects: '/projects1'
    }
    return (
        <div className="container">
            <div classNameName="b-title">
                <Tittle title={one.title} span={one.title} />
            </div>
            <div className='py-5'>
                <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={p11} className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={p12} className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={p13} className="d-block w-100" alt="..." />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
            <div>
                <div className='row-12'>

                    <p>
                        <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={one.link}>{one.live}</a></button>
                        <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={one.linkgc}>{one.git}</a></button>
                        <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={one.linkgs}>{one.gits}</a></button>
                    </p>
                    <h1>Project Name :{one.title}</h1>
                </div>
                <div className='row-12'>
                    <ul>
                        <li>It is a Laptop Related Responsive Website. Which serves many laptops like HP Laptop, many others Configuration HP Laptop, etc.?</li>
                        <li>Users and Admin can sign up and log in to this website using Google. Anyone cannot go to some pages without login, which is developed by React Router. • There are dashboards for User and Admin. For Admin, he/she can control all orders and as well as product also.</li>
                        <li>	Users can place orders, see his order list, and give a review of a service. Admin  can see all orders of the users. They can add a new service and make a new admin  by providing the new admin’s email.</li>
                    </ul>
                    <p><strong>Front-end Technology: </strong>HTML5, CSS3, Bootstrap5, React.js, React-Router, JSX. </p>
                    <p><strong>Back-end Technology: </strong>Node JS, Express JS, Mongo DB, Firebase.</p>
                </div>
            </div>
        </div>
    );
};

export default ProjectsOne;